module.exports = __webpack_public_path__ + "img/1_030.7f212902.jpg";